<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/9/2020
  -->

<template>
	<div class="radio-element-root">
		<FormMultipleView
			ref="formMultipleView"
			:formElement="formElement"
			:viewMode="viewMode"
			v-bind="$attrs"
			>
			<template #contentEditMode>

				<div>
					<div class="qwoach-form qw-row-md mt-2 disableClick" @click.prevent>
						<qw-input
							:readonly="true"
							class="qw-col mr-4"
							placeholder="Full Name"
							:borderDotted="true"/>
						<qw-input
							:readonly="true"
							class="qw-col mr-4"
							placeholder="Contact information"
							:borderDotted="true"/>
						<qw-input
							v-if="formElement.addRelationship"
							:readonly="true"
							class="qw-col"
							placeholder="Relationship"
							:borderDotted="true"/>
						<ToolTipView>
							This is a preview of what your client will see.
							<!--						<br/><br/>-->
							<!--						Your client will be able to add multiple contacts.-->
						</ToolTipView>
					</div>
					<small v-if="formElement.allowAddingOptions && !isSelected" class="text-muted">
						<span class="fontello icon-ok"/> Client can add multiple contacts</small>

					<div class="mt-4" v-if="isSelected">
						<div>
							<qw-checkbox
								v-model="formElement.allowAddingOptions"
								@change="notifyElementChanged">
								Client can add multiple contacts
							</qw-checkbox>
						</div>
						<div>
							<qw-checkbox
								v-model="formElement.addRelationship"
								@change="notifyElementChanged">
								Ask for relationship
							</qw-checkbox>
						</div>
					</div>

				</div>
			</template>

			<template #viewList="{formElement}">

				<div class="qw-row mb-2" v-for="(contactInfo, index) in formElement.answerOptions" :key="index">
					<qw-input
						:readonly="!isAnswerMode"
						class="col-sm mr-2 mt-2"
						:class="{'white-smoke': isAnswerMode}"
						:placeholder="isAnswerMode ? 'Full Name' : 'No answer provided'"
						v-model="contactInfo.fullName"
						:borderDotted="!isAnswerMode"/>
					<qw-input
						:readonly="!isAnswerMode"
						class="col-sm mr-2 mt-2"
						:class="{'white-smoke': isAnswerMode}"
						:placeholder="isAnswerMode ? 'Contact information' : 'No answer provided'"
						v-model="contactInfo.contactDetails"
						:borderDotted="!isAnswerMode"/>
					<qw-input
						v-if="formElement.addRelationship"
						:readonly="!isAnswerMode"
						class="col-sm mt-2"
						:class="{'white-smoke': isAnswerMode}"
						placeholder="Relationship"
						v-model="contactInfo.relationship"
						:borderDotted="!isAnswerMode"/>

<!--					<div v-if="isAnswerMode && formElement.answerOptions.length > 1" class="layout-spacer"></div>-->
					<qw-button-delete v-if="isAnswerMode && formElement.answerOptions.length > 1" @click="deleteOption(index)"/>
				</div>

				<qw-link-button v-if="isAnswerMode && formElement.allowAddingOptions" @click="addOption">
					+ Add one more contact
				</qw-link-button>

				<!--				<FormRow :showDivider="false">-->
				<!--					<el-radio-group v-model="formElement.selectedIndex" class="w-100"-->
				<!--					@change="onRadioChanged(formElement)">-->
				<!--						<div v-for="(option, index) in formElement.answerOptions" :key="index" class="item-height row mx-0 align-items-center"-->
				<!--						:class="{disableClick: isViewMode, 'answer': isAnswerMode}"-->
				<!--						@click="onRadioClicked">-->
				<!--							<el-radio :label="index" :class="{'input-disabled': isViewMode}">{{ option }}</el-radio>-->
				<!--						</div>-->

				<!--						<div v-if="formElement.showOtherOption" class="item-height row mx-0 align-items-center"-->
				<!--							 :class="{disableClick: isViewMode, 'answer': isAnswerMode}"-->
				<!--							 @click="onRadioClicked">-->
				<!--							<el-radio :label="otherIndex" :class="{'input-disabled': isViewMode}">Other:</el-radio>-->
				<!--							<div class="col px-0">-->
				<!--								<qw-input v-model="formElement.otherAnswer"-->
				<!--										  :readonly="!isAnswerMode"-->
				<!--										  @input="onOtherTextChanged(formElement)"></qw-input>-->
				<!--							</div>-->
				<!--						</div>-->
				<!--					</el-radio-group>-->
				<!--				</FormRow>-->
			</template>
		</FormMultipleView>
	</div>


</template>

<script>
import FormMultipleView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementMultipleView.vue";
import BaseFormElementView from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import QwButtonDelete from "@/core/components/Controls/Buttons/QwButtonDelete.vue";
import ContactInfo from "@shared/Profile/ContactInfo";
import FormElementContactInfo
	from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementContactInfo";

export default {
	name: "FormElementContactInfoView",
	components: {QwButtonDelete, ToolTipView, FormMultipleView},
	extends: BaseFormElementView,
	props: {
		formElement: {FormElementContactInfo, required: true}
	},


	methods: {

		addOption() {
			this.formElement.answerOptions.push(new ContactInfo())
			this.notifyAnswerOptionsChanged()
			this.notifyElementChanged()
		},

		deleteOption(index) {
			return this.$refs.formMultipleView.deleteOption(index)
		},

	},

	computed: {
		otherIndex() {
			return this.formElement.answerOptions.length
		}
	}


}
</script>

<style lang="scss">

.radio-element-root {
	.disableClick {
		cursor: default;
		outline: none;

		.el-radio__inner {
			border: 1px solid #DCDFE6;
			box-shadow: none !important;
			cursor: default;
		}

		.editMode {
			.el-radio__label {
				padding-left: 0;
			}
		}

		.el-radio, .el-radio__input, .el-radio__label, .el-radio__inner {
			cursor: default;
		}
	}
}

</style>
